<template>
  <div class="m-content">
    <CareerMajor v-if="step1" :content="carrerArray" :mode="'search'" v-on:listenToChildEvent="getListCareer"></CareerMajor>
    <CareerCategory v-if="step2" :content="listCareer" :selected="[]" :mode="'search'" v-on:listenToChildEvent="getCareerCategory"></CareerCategory>
    <div class="button-box">
      <button class="default-btn large-btn" @click="Back">返回</button>
    </div>
  </div>
</template>
<script>
import CareerCategory from '../components/CareerCategory.vue'
import CareerMajor from '../components/CareerMajor.vue'
  export default {
    props: {
      id: Number
    },
    name: 'CareerSearch',
    components: {
      'CareerCategory':CareerCategory,
      'CareerMajor':CareerMajor
    },
    data() {
      return {
        carrerArray:[
          [{'career':'金融','count':85},{'career':'政府与公共事务','count':17}],
          [{'career':'企业管理与行政','count':105},{'career':'法律、公共安全、惩教及保安','count':36}],
          [{'career':'教育&培训','count':47},{'career':'艺术、音像技术与传播','count':91}],
          [{'career':'科学、技术、工程和数学','count':109},{'career':'生产制造','count':204}],
          [{'career':'建筑与施工','count':90},{'career':'公共事业/社会服务','count':61}],
          [{'career':'运输、配送&物流','count':87},{'career':'酒店&旅游&休闲娱乐&体育','count':37}],
          [{'career':'农业、食品和自然资源','count':42},{'career':'市场营销','count':111}],
          [{'career':'信息技术','count':104},{'career':'医疗保健','count':151}],
        ],
        listCareer:[],
        step1:true,
        step2:false,
      }
    },
    methods: {
      // 获取职业群下的职业信息
      getListCareer(arr){
        this.listCareer = arr
        this.step1 = false
        this.step2 = true
        this.showButton = true
      },
      getCareerCategory(){
      },
      // 返回按钮的事件，在职业信息页时返回到职业群，在职业群时返回多宝库页面
      Back(){
        if(this.step2){
          this.step1 = true
          this.step2 = false
        }else{
          this.$emit("listenToChildEvent")
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .m-content
    min-height:100%
    /deep/ .career-box
        max-height:80vh
    /deep/ .career-category
        max-height:75vh
</style>
